import React from 'react';
import PCHeader from '../../components/PCHeader';
import styled from "styled-components";

import PCNav from '../../components/PCNav';

const Wrap = styled.div`
    width: 100%;
    height: 100vh;
`;

const PostHeader = styled.div`
    padding-top: 100px;
    width: 100%;

    background-color: #2b2a2a;
    display: flex;
    justify-content: center;
    align-items: center;
    h2 {
        font-size: 20px;
        color: white;
    }
`


const Posts = () => {

    return (
    <Wrap>
        <PCHeader />  
            <PostHeader>
            </PostHeader>
            <PCNav />


                    {/* <iframe 
                    width="100%"
                    height="100%"
                    src="http://localhost:3000/post/0005" 
                    title="치과통" 
                    frameBorder="0" 
                    >
                    </iframe> */}
              
    </Wrap>
    );
};

export default Posts;